export function stripWrappingParagraphTag(copy) {
  return copy.replace("<p>", "").replace("</p>", "");
}
